import { render, staticRenderFns } from "./sezioniDettaglio.html?vue&type=template&id=2b2011ac&"
import script from "./SezioniDettaglio.vue?vue&type=script&lang=js&"
export * from "./SezioniDettaglio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports